import { render, staticRenderFns } from "./relatorioContato.vue?vue&type=template&id=153ed674"
import script from "./relatorioContato.vue?vue&type=script&lang=js"
export * from "./relatorioContato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports